var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',{staticClass:"cursor-pointer text-decoration-underline",on:{"click":_vm.showExecutionModal}},[_vm._v(_vm._s(_vm.$t('common.seeDetails')))])
}
var staticRenderFns = []

export { render, staticRenderFns }